export default __webpack_public_path__ + "static/media/5.c2def231.png";